
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './Navbar/navbar';
import Home from './Pages/Home';
import ScheduleAppointment from './Pages/Schedule_Appointment';
import Services from './Pages/Services';
import Location from './Location/Location';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/Location' element={<Location />} />
        <Route path='/Appointment' element={<ScheduleAppointment />} />
        <Route path='/Services' element={<Services />} />
      </Routes>
    </Router>
  );
}

export default App;
